// extracted by mini-css-extract-plugin
export var header = "Header-module--header--27Vfm";
export var minimal = "Header-module--minimal--GA4L- Header-module--header--27Vfm";